'use client'
import { filterConnectedWallets } from '../filterConnectedWallets/filterConnectedWallets.js';
import { staticWalletFilter } from '../staticLinkedWalletFilter/staticLinkedWalletFilter.js';
import { filterWalletConnectWallets } from '../filterWalletConnectWallets/filterWalletConnectWallets.js';

const applyMultiWalletFilters = ({ authMode, userWallets, walletOptions, walletBook, }) => {
    const walletList = filterWalletConnectWallets({
        userWallets,
        walletOptions,
    });
    if (authMode === 'connect-only') {
        return filterConnectedWallets({
            userWallets,
            walletOptions: walletList,
        });
    }
    return staticWalletFilter(userWallets, walletList, walletBook);
};

export { applyMultiWalletFilters };
